<template>
  <div class="photograph-warpper">
    <img class="paishe" :src="page.photoImgUrl" alt="" />
    <p>拍摄时正对标识 尽量满屏、清晰。</p>
    <img class="gif" :src="page.gifUrl" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    applet: {
      type: Object,
      default: () => {
        return {}
      }
    },
    page: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.photograph-warpper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  p {
    line-height: 1.5rem;
    color: #9e9ea0;
    font-size: 0.32rem;
  }
  .paishe {
    width: 3rem;
  }
  .gif {
    width: 5rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Photograph/index.vue